import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { PageHeader, SectionCard, Loader, KpiCard } from "@/components/common";
import { formatINR } from "@/lib/format";
import { Building2, Package, IndianRupee } from "lucide-react";

export default function Branches() {
  const [branches, setBranches] = useState(null);
  const [products, setProducts] = useState([]);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/branches"), api.get("/products"), api.get("/invoices")])
      .then(([b, p, i]) => { setBranches(b.data); setProducts(p.data); setInvoices(i.data); });
  }, []);
  if (!branches) return <Loader label="Loading branches…" />;

  const byBranch = branches.map((br) => {
    const bp = products.filter((p) => p.branch_id === br.id);
    const bi = invoices.filter((i) => i.branch_id === br.id);
    return {
      ...br,
      inventory: bp.reduce((s, p) => s + p.purchase_price * p.quantity, 0),
      products: bp.length,
      sales: bi.reduce((s, i) => s + i.total, 0),
      orders: bi.length,
    };
  });

  return (
    <div>
      <PageHeader title="Branches" subtitle="Manage all your stores from one place." />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <KpiCard testid="br-count" index={0} label="Branches" value={branches.length} icon={Building2} />
        <KpiCard testid="br-sales" index={1} label="Combined Sales" value={formatINR(byBranch.reduce((s, b) => s + b.sales, 0), { compact: true })} icon={IndianRupee} accent="success" />
        <KpiCard testid="br-inventory" index={2} label="Combined Inventory" value={formatINR(byBranch.reduce((s, b) => s + b.inventory, 0), { compact: true })} icon={Package} accent="primary" />
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {byBranch.map((b, i) => (
          <SectionCard key={b.id} testid={`branch-${b.id}`}>
            <div className="flex items-start gap-3">
              <div className="grid place-items-center h-11 w-11 rounded-lg bg-primary/10 text-primary shrink-0"><Building2 className="h-5 w-5" /></div>
              <div className="flex-1">
                <div className="font-heading text-lg font-semibold">{b.name}</div>
                <div className="text-xs text-muted-foreground">{b.location || "—"}</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 mt-4">
              <div className="rounded-lg bg-secondary p-3"><div className="text-xs text-muted-foreground">Sales</div><div className="font-heading font-bold">{formatINR(b.sales, { compact: true })}</div></div>
              <div className="rounded-lg bg-secondary p-3"><div className="text-xs text-muted-foreground">Orders</div><div className="font-heading font-bold">{b.orders}</div></div>
              <div className="rounded-lg bg-secondary p-3"><div className="text-xs text-muted-foreground">Inventory</div><div className="font-heading font-bold">{formatINR(b.inventory, { compact: true })}</div></div>
              <div className="rounded-lg bg-secondary p-3"><div className="text-xs text-muted-foreground">Products</div><div className="font-heading font-bold">{b.products}</div></div>
            </div>
          </SectionCard>
        ))}
      </div>
    </div>
  );
}
